package com.hyperether.goodjob.models

enum class WeekdayOption(val stringRes: String) {
    EVERY_WEEKDAY("repeat_daily_weekday"),
    EVERY_WORKING_DAY("repeat_daily_workday")
}
